import React, { useEffect, useState } from 'react'

import styles from "./Accordion.module.scss"
import AccordionSection from "./AccordionSection";
import InteractionContainer from './../../partials/InteractionContainer/InteractionContainer';
import Button from "../../partials/Button";
import Scroll from '../../partials/Scroll/Scroll';
import Media from '../../partials/Media';

// Reducer function for state management
const sectionsReducer = (state, action) => {
    switch (action.type) {
        case "ACTION_SET_AS_COMPLETED":
            const sectionToMarkAsCompleted = state.find(s => {
                return (s.id === action.payload)
            })
            if (sectionToMarkAsCompleted) {
                return [...state.slice(0, state.indexOf(sectionToMarkAsCompleted)),
                {
                    ...sectionToMarkAsCompleted,
                    isComplete: true,
                },
                ...state.slice(state.indexOf(sectionToMarkAsCompleted) + 1, state.length),
                ]
            }
            break
        case "ACTION_CLICKED":
            //Deselect all sections
            state.forEach(s => {
                s.isSelected = false
                s.sections.forEach(ss => {
                    ss.isSelected = false;
                    ss.sections.forEach(sss => {
                        sss.isSelected = false
                    })
                })
            })

            const section = state.find(s => {
                return (s.id === action.payload.item)
            })

            // a Main section was clicked
            if (section) {
                console.log(section)
                return state.map(s => {
                    if (s.id === section.id) {
                        return {
                            ...section,
                            isExpanded: !section.isExpanded,
                            isSelected: true,
                            isComplete: s.sections.length === 0
                        }
                    }
                    if (action.payload.level === 1) {
                        return {
                            ...s,
                            isExpanded: false,
                        }
                    }
                    return s
                })
            }

            function isSectionCompleted(innerSections) {
                let isComplete = true;
                innerSections.forEach(is => {
                    if (is.isComplete === false) {
                        isComplete = false;
                    }
                }
                )

                return isComplete;
            }

            // A Subsection was clicked
            const updateSubSection = (subSection) => {
                const innerSections = subSection.sections.map(updateInnerSection);
                const isSectionComplete = isSectionCompleted(innerSections);
                if (action.payload.level === 2) {
                    if (subSection.id === action.payload.item) {
                        return { ...subSection, isExpanded: !subSection.isExpanded, isSelected: true, sections: innerSections, isComplete: isSectionComplete };
                    }
                    return { ...subSection, isExpanded: false, sections: innerSections };
                }
                return { ...subSection, sections: innerSections };
            };



            const updateInnerSection = (innerSection) => {
                if (innerSection.id === action.payload.item) {
                    return { ...innerSection, isComplete: true, isExpanded: true, isSelected: true };
                }
                return { ...innerSection, isExpanded: false };
            }

            const updateSection = (section) => ({
                ...section,
                sections: section.sections.map(updateSubSection),
            });
            return state.map(updateSection);
        default:
            throw new Error(`Unknown action ${state.type}`)
    }
}

function Accordion(props) {
    const { sections } = props.data || {}
    if (!sections) {
        throw new Error('No sections on Accordion props')
    }
    const { options } = props.data || {}
    const allowMultipleExpanded = options.allowMultipleExpanded || false
    const [currentSelected, setCurrentSelected] = useState()
    const [progress, setProgress] = useState({
        total: 0,
        completed: 0,
    })
    const [completion, setCompletion] = useState(0)

    const [accordionSections, dispatch] = React.useReducer(sectionsReducer,
        [], () => {
            const _accordionSections = []
            if (sections) {
                // First level
                sections.forEach(section => {
                    const subsections = []
                    // Second level
                    section.sections.forEach(ss => {
                        const innersections = []
                        // Third level
                        ss?.sections && ss.sections.forEach(is => {
                            innersections.push({
                                ...is,
                                id: `${is.caption}_${createUUID()}`,
                                sections: innersections,
                                isSubsection: true,
                                isExpanded: false,
                                isComplete: false,
                            })
                        })

                        subsections.push({
                            ...ss,
                            id: `${ss.caption}_${createUUID()}`,
                            sections: innersections,
                            isSubsection: true,
                            isExpanded: false,
                            isComplete: false,
                        })
                    })
                    _accordionSections.push({
                        ...section,
                        sections: subsections,
                        id: `${section.caption}_${createUUID()}`,
                        isSubsection: false,
                        isExpanded: false,
                        isComplete: false,
                    })
                })
                return _accordionSections
            }
        })
    useEffect(() => {
        let subsectionCount = 0
        accordionSections.forEach(section => {
            section.sections.forEach(s => {
                s.sections.forEach(ss => {
                    subsectionCount += 1;
                })
                subsectionCount += 1;
            })
        })
        setProgress({
            total: subsectionCount,
            completed: 0,
        })
        if (accordionSections.length > 0) {
            setCurrentSelected(accordionSections[0])
            dispatch({
                type: 'ACTION_CLICKED',
                payload: {
                    item: accordionSections[0].id,
                    allowMultipleExpanded,
                },
            })
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])

    useEffect(() => {

        setCompletion(progress.total > 0 ? (progress.completed / progress.total) * 100 : 0)
    }, [progress])

    useEffect(() => {
        if (completion === 100) {
            if (options.autoExecuteOnComplete === true && props.onComplete) {
                props.onComplete()
            }

        }

    }, [completion])

    useEffect(() => {
        if (!accordionSections) {
            return
        }
        let completedCount = 0;
        accordionSections.forEach(section => {
            let isComplete = true
            if(section.sections.length === 0) {
                isComplete = section.isComplete;
            }
            for (let i = 0; i < section.sections.length; i++) {

                let subsection = section.sections[i]
                let isSubsectionComplete = true
                if(subsection.sections.length === 0) {
                    isSubsectionComplete = subsection.isComplete;
                }
                for (let i = 0; i < subsection.sections.length; i++) {
                    let innerSection = subsection.sections[i]
                    if (innerSection.isComplete === false) {
                        isSubsectionComplete = false;
                        break;
                    } else {
                        completedCount += 1
                    }
                }
                subsection.isComplete = isSubsectionComplete
                if (subsection.isComplete === false) {
                    isComplete = false
                } else {
                    if (subsection.isComplete === false && isComplete === true) {
                        dispatch({
                            type: 'ACTION_SET_AS_COMPLETED',
                            payload: subsection.id,
                        })
                    }
                    completedCount += 1
                }
            }
            if (section.isComplete === false && isComplete === true) {
                dispatch({
                    type: 'ACTION_SET_AS_COMPLETED',
                    payload: section.id,
                })
            }
        })
        if (progress.total !== 0) {
            setProgress({
                ...progress,
                completed: completedCount
            })
        }
    }, [accordionSections]);


    let itHaveImage = (currentSelected !== undefined
        && currentSelected.image !== undefined
        && currentSelected.image !== "");

        useEffect(() => {

            itHaveImage = (currentSelected !== undefined
                && currentSelected.image !== undefined
                && currentSelected.image !== "");
        }, [currentSelected])

    const imageSection = (itHaveImage) ?
        (<div className={styles.vertical}>
            
            <Media
                src={currentSelected.image}
                alt={currentSelected.imageAlt}
                imgStyle = {{maxHeight : "290px"}}
                style={{
                    height: `Auto`,
                    display: `flex`,
                    justifyContent: `center`,
                    maxHeight: `290px`
                }}
            ></Media>
        </div>)
        : null;

    var contentClassName = styles.accordion_content;

    if (itHaveImage)
        contentClassName += (currentSelected !== undefined
            && currentSelected.imageHorizontal === true)
            ? ` ${styles.horizontal}`
            : ` ${styles.vertical}`;

    // For audio
    // For audio
    const itHaveAudio = (currentSelected !== undefined
        && currentSelected.audioUrl !== undefined
        && currentSelected.audioUrl !== "");

    const audioSection = (itHaveAudio) ?
        (<div className={styles.vertical}>
            <Media
                src={currentSelected.audioUrl}
                style={{
                    width: `100%`,
                    display: `flex`,
                    justifyContent: `center`,
                }}
            ></Media>
        </div>)
        : null;

    var contentClassName = styles.accordion_content;

    if (itHaveAudio)
        contentClassName += (currentSelected !== undefined
            && currentSelected.imageHorizontal === true)
            ? ` ${styles.horizontal}`
            : ` ${styles.vertical}`;


    return <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
        <div className="back-btn-container" style={{ zIndex: 10 }} >
            <Button variant={'back'} text={'BACK'} onClick={() => {
                props.goBackToPreviousSegment()
            }} />
        </div>
        <div className={styles.root}>
            {/* <div className={styles.progress_container} >
                <div className={styles.progress} >{completion.toFixed(0)}  %</div>
            </div> */}
            <div className={styles.accordion_container}>
                <Scroll>
                    <div className={styles.accordion_sections}>
                        {accordionSections && accordionSections.map(section => {
                            return <AccordionSection
                                // class={`accordion-section ${section.isExpanded ? 'expanded' : 'collapsed'}`}
                                key={section.id}
                                section={section}
                                onSelected={(selected, level) => {
                                    setCurrentSelected(selected)
                                    dispatch({
                                        type: 'ACTION_CLICKED',
                                        payload: {
                                            item: selected.id,
                                            level: level,
                                            allowMultipleExpanded,
                                        },
                                    })
                                }}
                            />
                        })}
                    </div>
                </Scroll>
                <div className={contentClassName}>
                    <Scroll>
                        <div className={itHaveImage? styles.current_selected_withImage : styles.current_selected} >
                            <div dangerouslySetInnerHTML={{
                                __html: currentSelected ? currentSelected.content : ''
                            }}>
                            </div>
                            {audioSection}
                        </div>
                    </Scroll>
                    {imageSection}
                </div>
            </div>

            <div className={styles.button_container}>
                <Button
                    text={options.buttonText || "Next"}
                    onClick={() => {
                        if (props.onComplete) {
                            props.onComplete()
                        }
                        if (props.markComplete) {
                            props.markComplete()
                        }
                    }}
                />
            </div>

        </div>
    </InteractionContainer>
}

function createUUID() {
    return '_' + Math.random().toString(36).substr(2, 9);
}

export default Accordion;

